import { DatePipe, formatDate } from "@angular/common";
import { environment } from "src/environments/environment";
import { ConstantesApp } from "../app.config/constantes-app";
import { Cliente } from "../app.domain.models/cliente";
import { EmailTemplate } from "../app.domain.models/email-template";
import { EnvioEmail } from "../app.domain.models/envio-email";
import { FormularioPresupuesto } from "../app.domain.models/formulario-presupuesto";
import { FormularioSolicitud } from "../app.domain.models/formulario-solicitud";
import { FormularioSolicitudCambiarBeneficiarios } from "../app.domain.models/formulario-solicitud-cambiar-beneficiarios";
import { FormularioSolicitudReducirCapital } from "../app.domain.models/formulario-solicitud-reducir-capital";
import { Poliza } from "../app.domain.models/poliza";
import { EmailTemplateApiService } from "../app.domain.services/email-template.api.service";
import { EnvioEmailApiService } from "../app.domain.services/envio-email.api.service";
import { LogaltyApiService } from "../app.domain.services/logalty.api.service";
import { PdfApiService } from "../app.domain.services/pdf.api.service";
import { Archivo } from "../core.models/archivo";
import { UserService } from "../core.services/user.service";
import { ConstantesCore } from "../core.utilidades/constantes-core";
import { PipeCurrencyEuro } from "../core.utilidades/pipeEuro";
import { PipeCurrencyEuroSinDecimales } from "../core.utilidades/pipeEuroSinDecimales";
import { Utilidades as UtilidadesCore } from "../core.utilidades/utilidades";
import { PolizaApiService } from "../app.modules/individual/domain.services/poliza.api.service";

export class Utilidades extends UtilidadesCore {
    public static generarPdfColectivoCobertura(cliente: Cliente, poliza: Poliza, pdfService: PdfApiService, datePipe: DatePipe) {
        return new Promise<Archivo>((resolve, reject) => {
            const formularioPresupuesto = new FormularioPresupuesto();
            formularioPresupuesto.clienteId = cliente.id;
            formularioPresupuesto.titular = Utilidades.getNombreCompletoCliente(cliente);
            formularioPresupuesto.nacimiento = datePipe.transform(cliente.fechaNacimiento, 'yyyy-MM-dd')!.toString();
            formularioPresupuesto.email = cliente.email;
            formularioPresupuesto.telefono = cliente.telefono;
            formularioPresupuesto.formaPago = poliza.tipoPeriodicidad?.descripcion!;
            formularioPresupuesto.fechaInicioCobertura = '';
            formularioPresupuesto.profesion = cliente.profesion;
            formularioPresupuesto.tipoPoliza = poliza.tipoPoliza!.nombre;
            formularioPresupuesto.tipoPolizaDescripcion = poliza.tipoPoliza!.descripcion;
            formularioPresupuesto.fallecimientoCausa = poliza.capitalCobertura;
            formularioPresupuesto.fallecimientoAccidente = poliza.capitalAccidenteFallecimiento;
            formularioPresupuesto.invalidezAccidente = poliza.capitalAccidenteInvalidez;
            formularioPresupuesto.precioMensual = poliza.precioMensual;
            formularioPresupuesto.nombreAgente = poliza.colectivo!.agente!.nombreApellidos;
            formularioPresupuesto.emailAgente = poliza.colectivo!.agente!.email;
            formularioPresupuesto.telefonoAgente = poliza.colectivo!.agente!.telefono;
            formularioPresupuesto.urlLogo = poliza.colectivo!.archivoLogo.url;

            pdfService
                .generarPdfColectivoCobertura(formularioPresupuesto)
                .then((pdf: Archivo) => {
                    resolve(pdf);
                });
        });

    }
    public static getNombreCompletoCliente(cliente: Cliente): string {
        return cliente.nombre + ' ' + cliente.apellido1 + (cliente.apellido2 ? ' ' + cliente.apellido2 : '');
    }

    public static getApellidos(persona: Cliente): string {
        return persona.apellido1.concat(' ').concat(persona.apellido2 !== null ? persona.apellido2 : '');
    }

    // Enviar los emails a los beneficiarios a los que se le haya aceptado la comunicacion
    public static enviarMailBeneficiarios(poliza: Poliza, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, variables: any) {
        // recuperamos la plantilla
        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_BENEFICIARIOS_ID).then((template: EmailTemplate) => {
            if (template) {
                let i = 0;
                for (const beneficiario of poliza.beneficiarioList) {
                    i++;
                    setTimeout(() => {
                        if (beneficiario.comunicarEmail && beneficiario.email?.length > 0) {
                            variables.usuario = beneficiario.nombreCompleto;
                            variables.tipoPoliza = poliza.tipoPoliza.descripcion;
                            variables.formaPago = poliza.tipoPeriodicidad?.descripcion;

                            const asunto = Utilidades.rellenarPlantilla(template.asunto, variables);
                            const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variables);
                            let envioEmail = new EnvioEmail();
                            envioEmail.asunto = asunto;
                            envioEmail.cuerpo = cuerpo;
                            envioEmail.fecha = new Date();
                            envioEmail.enviado = 0;
                            envioEmail.adjuntos = [];
                            envioEmail.destinatario = beneficiario.email;
                            envioEmailService.crear(envioEmail);
                        }
                    }, i * 1000);
                }
            }
        });
    }

    // Enviar los emails a los beneficiarios a los que se le haya aceptado la comunicacion
    public static enviarMailBeneficiariosIndividual(poliza: Poliza, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, variables: any) {
        // recuperamos la plantilla
        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_BENEFICIARIOS_INDIVIDUAL_ID).then((template: EmailTemplate) => {
            if (template) {
                let i = 0;
                for (const beneficiario of poliza.beneficiarioList) {
                    i++;
                    setTimeout(() => {
                        if (beneficiario.comunicarEmail && beneficiario.email?.length > 0) {
                            variables.usuario = beneficiario.nombreCompleto;
                            const asunto = Utilidades.rellenarPlantilla(template.asunto, variables);
                            const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variables);
                            let envioEmail = new EnvioEmail();
                            envioEmail.asunto = asunto;
                            envioEmail.cuerpo = cuerpo;
                            envioEmail.fecha = new Date();
                            envioEmail.enviado = 0;
                            envioEmail.adjuntos = [];
                            envioEmail.destinatario = beneficiario.email;
                            envioEmailService.crear(envioEmail);
                        }
                    }, i * 1000);
                }
            }
        });
    }

    // Obtiene la fecha actual en el formato yyyy-MM-dd
    static getDateYYYYMMDDfromJSDate(fecha: Date) {
        return formatDate(fecha, ConstantesCore.DATE_FORMAT_YYYY_MM_DD, ConstantesCore.UNICODE_ES);
    }

    // Enviar email al cliente con la poliza solcitada
    public static enviarMailClientePoliza(pdfPresupuesto: Archivo, poliza: Poliza, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales) {
        // recuperamos la plantilla
        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_COLECTIVO_ID).then((template: EmailTemplate) => {
            if (template) {

                // preparamos las variables
                let variables: object = Utilidades.getVariablesEmail(pdfPresupuesto, poliza, pipeEuroSinDecimales);
                const asunto = Utilidades.rellenarPlantilla(template.asunto, variables);
                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variables);

                const envioEmail = new EnvioEmail();
                envioEmail.destinatario = poliza.cliente.email;
                envioEmail.asunto = asunto;
                envioEmail.cuerpo = cuerpo;
                envioEmail.fecha = new Date();
                envioEmail.enviado = 0;

                envioEmail.adjuntos = [];

                if (template.archivos) {
                    // Adjuntar los adjuntos de la plantilla
                    for (const adjuntoPlantilla of template.archivos) {
                        const archivo = new Archivo();
                        archivo.id = adjuntoPlantilla.id;
                        envioEmail.adjuntos.push(archivo);
                    }
                }

                envioEmail.adjuntos.push(pdfPresupuesto);
                envioEmailService.crear(envioEmail);
            }
        });
    }

    // Obtener las variables del email
    public static getVariablesEmail(pdfPresupuesto: Archivo, poliza: Poliza, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales): object {
        let beneficiarios: any[] = [];
        let urlActual = new URL(window.location.href).origin;
        let pathLogin = `${urlActual}${ConstantesApp.PATH_USER_LOGIN}`;
        const isFamilia = poliza.tipoPoliza.id === 1 ? true : false;
        const beneficiarioListOrdenado = poliza.beneficiarioList.sort((a, b) => a.orden! - b.orden!);

        for (const b of beneficiarioListOrdenado) {
            const beneficiarioEmail = {
                nombreCompleto: b.esBanco ? b.nombreBanco + ' - Nº Préstamo: ' + b.numeroPrestamo : b.nombreCompleto,
                porcentaje: isFamilia ? b.porcentaje + ' %' : ''

            };
            beneficiarios.push({
                beneficiario: beneficiarioEmail,
            });
        }

        return {
            staticContentPath: environment.staticContentPath,
            orientado: poliza.cliente.tipoSexo!.id == 1 ? 'o' : 'a',
            usuario: poliza.cliente.nombre,
            titular: poliza.cliente.nombre,
            medioContratacion: 'Internet',
            formaPago: poliza.tipoPeriodicidad?.descripcion,
            inicioPoliza: '',
            tipoPoliza: poliza.tipoPoliza.descripcion,
            tipoPolizaId: poliza.tipoPoliza.id,
            fallecimientoCausaCapital: pipeEuroSinDecimales.transform(poliza.capitalCobertura),
            fallecimientoAccidenteCapital: pipeEuroSinDecimales.transform(poliza.capitalAccidenteFallecimiento),
            invalidezAccidenteCapital: pipeEuroSinDecimales.transform(poliza.capitalAccidenteInvalidez),
            precioMensual: pipeEuroSinDecimales.transform(poliza.precioMensual),
            list: beneficiarios,
            enlaceDescargaPdf: environment.staticContentPath + pdfPresupuesto.url,
            enlaceLogin: pathLogin,
            urlLogo: poliza.colectivo?.archivoLogo.url,
        }
    }

    // Obtener las variables del email
    public static getVariablesEmailIndividual(pdfPresupuesto: Archivo, poliza: Poliza, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales): object {
        let beneficiarios: any[] = [];
        let urlActual = new URL(window.location.href).origin;
        let pathLogin = `${urlActual}${ConstantesApp.PATH_USER_LOGIN}`;
        const isFamilia = poliza.tipoPoliza.id === 1 ? true : false;
        const beneficiarioListOrdenado = poliza.beneficiarioList.sort((a, b) => a.orden! - b.orden!);

        for (const b of beneficiarioListOrdenado) {
            const beneficiarioEmail = {
                nombreCompleto: b.esBanco ? b.nombreBanco + ' - Nº Préstamo: ' + b.numeroPrestamo : b.nombreCompleto,
                // porcentaje: b.esBanco ? '' : b.porcentaje + ' %'
                porcentaje: isFamilia ? b.porcentaje + ' %' : ''
            };
            beneficiarios.push({
                beneficiario: beneficiarioEmail,
            });
        }

        if (poliza.beneficiariosHerederosLegales) {
            const beneficiarioEmail = {
                nombreCompleto: ConstantesApp.BENEFICIARIOS_HEREDEROS_LEGALES,
                porcentaje: ''
            };
            beneficiarios.push({
                beneficiario: beneficiarioEmail,
            });
        }

        const fallecimientoAccidente = poliza.incluidoFallecimientoAccidente ? '<tr><td style="font-size: 0.8rem;text-align: left;padding: 8px 5px;">Fallecimiento x Accidente</td><td style="font-size: 0.8rem;text-align: center;padding: 8px 5px;">' + pipeEuroSinDecimales.transform(poliza.capitalAccidenteFallecimiento) + '</td></tr>' : ''
        const incapacidadAccidente = poliza.incluidoInvalidezAccidente ? '<tr><td style="font-size: 0.8rem;text-align: left;padding: 8px 5px 20px 5px;">Incapacidad Permanente Absoluta (IPA)</td><td style="font-size: 0.8rem;text-align: center;padding: 8px 5px 20px 5px">' + pipeEuroSinDecimales.transform(poliza.capitalAccidenteInvalidez) + '</td></tr>' : ''

        return {
            staticContentPath: environment.staticContentPath,
            orientado: poliza.cliente.tipoSexo!.id == 1 ? 'o' : 'a',
            usuario: poliza.cliente.nombre,
            titular: poliza.cliente.nombre,
            medioContratacion: 'Internet',
            formaPago: poliza.tipoPeriodicidad?.descripcion,
            inicioPoliza: '',
            tipoPoliza: poliza.tipoPoliza.descripcion,
            tipoPolizaId: poliza.tipoPoliza.id,
            incluidoFallecimientoAccidente: fallecimientoAccidente,
            incluidoInvalidezAccidente: incapacidadAccidente,
            fallecimientoCausaCapital: pipeEuroSinDecimales.transform(poliza.capitalCobertura),
            precioMensual: pipeEuroSinDecimales.transform(poliza.precioMensual),
            list: beneficiarios,
            enlaceDescargaPdf: environment.staticContentPath + pdfPresupuesto.url,
            enlaceLogin: pathLogin,
        }
    }

    // Obtener las variables del email de beneficiarios
    public static getVariablesEmailBeneficiairos(poliza: Poliza, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales): object {
        let beneficiarios: any[] = [];
        let cnt = 1;
        const beneficiarioListOrdenado = poliza.beneficiarioList.sort((a, b) => a.orden! - b.orden!);

        for (const beneficiario of beneficiarioListOrdenado) {
            beneficiarios.push({
                beneficiario: beneficiario,
                contador: cnt
            });
            cnt++;
        }

        const fallecimientoAccidente = poliza.incluidoFallecimientoAccidente ? '<tr><td style="font-size: 0.8rem;text-align: left;padding: 8px 5px;">Fallecimiento x Accidente</td><td style="font-size: 0.8rem;text-align: center;padding: 8px 5px;">' + pipeEuroSinDecimales.transform(poliza.capitalAccidenteFallecimiento) + '</td></tr>' : ''
        const incapacidadAccidente = poliza.incluidoInvalidezAccidente ? '<tr><td style="font-size: 0.8rem;text-align: left;padding: 8px 5px 20px 5px;">Incapacidad Permanente Absoluta (IPA)</td><td style="font-size: 0.8rem;text-align: center;padding: 8px 5px 20px 5px">' + pipeEuroSinDecimales.transform(poliza.capitalAccidenteInvalidez) + '</td></tr>' : ''

        return {
            staticContentPath: environment.staticContentPath,
            usuario: poliza.cliente.nombre,
            titular: poliza.cliente.nombre,
            fallecimientoCausaCapital: pipeEuroSinDecimales.transform(poliza.capitalCobertura),
            incluidoFallecimientoAccidente: fallecimientoAccidente,
            incluidoInvalidezAccidente: incapacidadAccidente,
            precioMensual: pipeEuroSinDecimales.transform(poliza.precioMensual),
            list: beneficiarios,
            urlLogo: poliza.colectivo?.archivoLogo.url,
        }
    }

    // Enviar email de compannia con pdf completo y anonimo
    public static enviarMailCompannia(poliza: Poliza, pdfCompanniaCompleto: Archivo, pdfCompanniaAnonimo: Archivo, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService) {
        // recuperamos la plantilla
        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_COMPANNIA_ID).then((template: EmailTemplate) => {
            if (template) {

                // preparamos las variables
                let variables: object = Utilidades.getVariablesEmailCompannia(poliza, pdfCompanniaCompleto, pipeEuroSinDecimales);
                const asunto = Utilidades.rellenarPlantilla(template.asunto, variables);
                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variables);
                const agente = poliza.colectivo?.agente ? poliza.colectivo.agente : poliza.tipoPoliza?.agente;
                const envioEmail = new EnvioEmail();
                envioEmail.destinatario = agente.email;
                envioEmail.asunto = asunto;
                envioEmail.cuerpo = cuerpo;
                envioEmail.fecha = new Date();
                envioEmail.enviado = 0;

                envioEmail.adjuntos = [];

                if (template.archivos) {
                    // Adjuntar los adjuntos de la plantilla
                    for (const adjuntoPlantilla of template.archivos) {
                        const archivo = new Archivo();
                        archivo.id = adjuntoPlantilla.id;
                        envioEmail.adjuntos.push(archivo);
                    }
                }

                envioEmail.adjuntos.push(pdfCompanniaCompleto);
                envioEmail.adjuntos.push(pdfCompanniaAnonimo);
                if (poliza.archivoClienteDni?.archivo?.fecha) {
                    poliza.archivoClienteDni.archivo.fecha = new Date(poliza.archivoClienteDni.archivo.fecha);
                    envioEmail.adjuntos.push(poliza.archivoClienteDni.archivo);
                }
                if (poliza.archivoClienteDniReverso?.archivo?.fecha) {
                    poliza.archivoClienteDniReverso.archivo.fecha = new Date(poliza.archivoClienteDniReverso.archivo.fecha);
                    envioEmail.adjuntos.push(poliza.archivoClienteDniReverso.archivo);
                }
                if (poliza.archivoReciboHipoteca?.fecha) {
                    poliza.archivoReciboHipoteca.fecha = new Date(poliza.archivoReciboHipoteca.fecha);
                    envioEmail.adjuntos.push(poliza.archivoReciboHipoteca);
                }
                envioEmailService.crear(envioEmail);
            }
        });

    }

    public static enviarMailCompanniaIndividual(poliza: Poliza, pdfRellenableSolicitud: Archivo, pdfRellenableAkibu: Archivo, pdfRellenableAkibuSinNumeroPoliza: Archivo, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService) {
        // recuperamos la plantilla
        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_INDIVIDUAL_COMPANNIA_ID).then((template: EmailTemplate) => {
            if (template) {

                // preparamos las variables
                let variables: object = Utilidades.getVariablesEmailCompannia(poliza, pdfRellenableSolicitud, pipeEuroSinDecimales);
                const asunto = Utilidades.rellenarPlantilla(template.asunto, variables);
                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variables);
                const agente = poliza.colectivo?.agente ? poliza.colectivo.agente : poliza.tipoPoliza?.agente;
                const envioEmail = new EnvioEmail();
                envioEmail.destinatario = agente.email;
                envioEmail.asunto = asunto;
                envioEmail.cuerpo = cuerpo;
                envioEmail.fecha = new Date();
                envioEmail.enviado = 0;

                envioEmail.adjuntos = [];

                if (template.archivos) {
                    // Adjuntar los adjuntos de la plantilla
                    for (const adjuntoPlantilla of template.archivos) {
                        const archivo = new Archivo();
                        archivo.id = adjuntoPlantilla.id;
                        envioEmail.adjuntos.push(archivo);
                    }
                }

                envioEmail.adjuntos.push(pdfRellenableAkibu);
                envioEmail.adjuntos.push(pdfRellenableAkibuSinNumeroPoliza);
                envioEmail.adjuntos.push(pdfRellenableSolicitud);
                if (poliza.archivoClienteDni?.archivo?.fecha) {
                    poliza.archivoClienteDni.archivo.fecha = new Date(poliza.archivoClienteDni.archivo.fecha);
                    envioEmail.adjuntos.push(poliza.archivoClienteDni.archivo);
                }
                if (poliza.archivoClienteDniReverso?.archivo?.fecha) {
                    poliza.archivoClienteDniReverso.archivo.fecha = new Date(poliza.archivoClienteDniReverso.archivo.fecha);
                    envioEmail.adjuntos.push(poliza.archivoClienteDniReverso.archivo);
                }
                if (poliza.archivoReciboHipoteca?.fecha) {
                    poliza.archivoReciboHipoteca.fecha = new Date(poliza.archivoReciboHipoteca.fecha);
                    envioEmail.adjuntos.push(poliza.archivoReciboHipoteca);
                }
                envioEmailService.crear(envioEmail);
            }
        });

    }

    // Enviar email al cliente con la poliza solcitada
    public static enviarMailClientePolizaIndividual(pdfRellenableAkibu: Archivo, poliza: Poliza, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales) {
        // recuperamos la plantilla
        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_INDIVIDUAL_BIENVENIDO_ID).then((template: EmailTemplate) => { //Moificar constante para añadir plantilla de individual
            if (template) {

                // preparamos las variables
                let variables: object = Utilidades.getVariablesEmailIndividual(pdfRellenableAkibu, poliza, pipeEuroSinDecimales);
                const asunto = Utilidades.rellenarPlantilla(template.asunto, variables);
                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variables);

                const envioEmail = new EnvioEmail();
                envioEmail.destinatario = poliza.cliente.email;
                envioEmail.asunto = asunto;
                envioEmail.cuerpo = cuerpo;
                envioEmail.fecha = new Date();
                envioEmail.enviado = 0;

                envioEmail.adjuntos = [];

                if (template.archivos) {
                    // Adjuntar los adjuntos de la plantilla
                    for (const adjuntoPlantilla of template.archivos) {
                        const archivo = new Archivo();
                        archivo.id = adjuntoPlantilla.id;
                        envioEmail.adjuntos.push(archivo);
                    }
                }

                envioEmail.adjuntos.push(pdfRellenableAkibu);
                envioEmailService.crear(envioEmail);
            }
        });
    }

    // Obtener las variables del email que se envia a la compannnia
    public static getVariablesEmailCompannia(poliza: Poliza, pdfCompanniaCompleto: Archivo, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales): object {
        let beneficiarios: any[] = [];
        let urlActual = new URL(window.location.href).origin;
        let pathLogin = `${urlActual}${ConstantesApp.PATH_USER_LOGIN}`;
        const isFamilia = poliza.tipoPoliza.id === 1 ? true : false;

        const beneficiarioListOrdenado = poliza.beneficiarioList.sort((a, b) => a.orden! - b.orden!);

        for (const b of beneficiarioListOrdenado) {
            const beneficiarioEmail = {
                nombreCompleto: b.esBanco ? b.nombreBanco + ' - Nº Préstamo: ' + b.numeroPrestamo : b.nombreCompleto,
                porcentaje: isFamilia ? b.porcentaje + ' %' : ''
            };
            beneficiarios.push({
                beneficiario: beneficiarioEmail,
            });
        }

        if (poliza.beneficiariosHerederosLegales) {
            const beneficiarioEmail = {
                nombreCompleto: ConstantesApp.BENEFICIARIOS_HEREDEROS_LEGALES,
                porcentaje: ''
            };
            beneficiarios.push({
                beneficiario: beneficiarioEmail,
            });
        }

        const fallecimientoAccidente = poliza.incluidoFallecimientoAccidente ? '<tr><td style="font-size: 0.8rem;text-align: left;padding: 8px 5px;">Fallecimiento x Accidente</td><td style="font-size: 0.8rem;text-align: center;padding: 8px 5px;">' + pipeEuroSinDecimales.transform(poliza.capitalAccidenteFallecimiento) + '</td></tr>' : ''
        const incapacidadAccidente = poliza.incluidoInvalidezAccidente ? '<tr><td style="font-size: 0.8rem;text-align: left;padding: 8px 5px 20px 5px;">Incapacidad Permanente Absoluta (IPA)</td><td style="font-size: 0.8rem;text-align: center;padding: 8px 5px 20px 5px">' + pipeEuroSinDecimales.transform(poliza.capitalAccidenteInvalidez) + '</td></tr>' : ''

        return {
            staticContentPath: environment.staticContentPath,
            orientado: poliza.cliente.tipoSexo!.id == 1 ? 'o' : 'a',
            usuario: poliza.cliente.nombre,
            titular: poliza.cliente.nombre + ' ' + poliza.cliente.apellido1 + ' ' + poliza.cliente.apellido2,
            medioContratacion: 'Internet',
            formaPago: poliza.tipoPeriodicidad?.descripcion,
            inicioPoliza: '',
            tipoPoliza: poliza.tipoPoliza.descripcion,
            tipoPolizaId: poliza.tipoPoliza.id,
            incluidoFallecimientoAccidente: fallecimientoAccidente,
            incluidoInvalidezAccidente: incapacidadAccidente,
            fallecimientoCausaCapital: pipeEuroSinDecimales.transform(poliza.capitalCobertura),
            fallecimientoAccidenteCapital: pipeEuroSinDecimales.transform(poliza.capitalAccidenteFallecimiento),
            invalidezAccidenteCapital: pipeEuroSinDecimales.transform(poliza.capitalAccidenteInvalidez),
            precioMensual: pipeEuroSinDecimales.transform(poliza.precioMensual),
            list: beneficiarios,
            enlaceDescargaPdf: environment.staticContentPath + pdfCompanniaCompleto.url,
            enlaceLogin: pathLogin
        }
    }

    public static getVariablesEmailEditarPoliza(tipoSolicitud: string, poliza: Poliza, fechaEfecto?: string): object {
        let urlActual = new URL(window.location.href).origin;
        let pathLogin = `${urlActual}${ConstantesApp.PATH_USER_LOGIN}`;

        let formattedFechaEfecto = '';
        if (fechaEfecto) {
            formattedFechaEfecto = `Con fecha efecto: ${fechaEfecto}`;
        }

        return {
            staticContentPath: environment.staticContentPath,
            usuario: poliza.cliente.nombre + ' ' + poliza.cliente.apellido1 + ' ' + poliza.cliente.apellido2,
            orientado: poliza.cliente.tipoSexo!.id == 1 ? 'o' : 'a',
            tipoSolicitud: tipoSolicitud,
            tipoPoliza: poliza.tipoPoliza.descripcion,
            numeroPoliza: poliza.numeroPoliza || '',
            enlaceLogin: pathLogin,
            fechaEfecto: formattedFechaEfecto
        };
    }


    public static enviarEmailsEditarPolizaCancelacion(formularioSolicitud: FormularioSolicitud, dniCliente: Archivo | undefined,
        dniClienteReverso: Archivo | undefined, tipoSolicitud: string, poliza: Poliza, emailTemplateService: EmailTemplateApiService,
        envioEmailService: EnvioEmailApiService, pdfService: PdfApiService, fechaEfecto?: string) {

        const cliente = poliza.cliente;
        const agente = poliza.colectivo?.agente ? poliza.colectivo.agente : poliza.tipoPoliza?.agente;

        pdfService.generarPdfSolicitud(formularioSolicitud)
            .then((pdfSolicitud: Archivo) => {
                if (cliente && agente) {
                    // Generar PDF de coberturas
                    Utilidades.generarPdfColectivoCobertura(poliza.cliente, poliza, pdfService, new DatePipe('en-US')).then((pdfCoberturas: Archivo) => {
                        const variablesCliente = Utilidades.getVariablesEmailEditarPoliza(tipoSolicitud, poliza, fechaEfecto);
                        const variablesAgente = Utilidades.getVariablesEmailEditarPoliza(tipoSolicitud, poliza, fechaEfecto);
                        const adjuntos: Archivo[] = [pdfCoberturas, pdfSolicitud];
                        if (dniCliente) {
                            adjuntos.push(dniCliente);
                        }
                        if (dniClienteReverso) {
                            adjuntos.push(dniClienteReverso);
                        }

                        // Enviar email al cliente
                        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ACCION_CLIENTE).then((template: EmailTemplate) => {
                            if (template) {
                                const asunto = Utilidades.rellenarPlantilla(template.asunto, variablesCliente);
                                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variablesCliente);
                                let emailCliente = new EnvioEmail();
                                emailCliente.destinatario = cliente.email;
                                emailCliente.asunto = asunto;
                                emailCliente.cuerpo = cuerpo;
                                emailCliente.fecha = new Date();
                                emailCliente.enviado = 0;
                                // Adjuntar PDFs
                                emailCliente.adjuntos = adjuntos;
                                envioEmailService.crear(emailCliente);
                            }
                        });

                        // Enviar email al agente
                        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ACCION_AGENTE).then((template: EmailTemplate) => {
                            if (template) {
                                const asunto = Utilidades.rellenarPlantilla(template.asunto, variablesAgente);
                                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variablesAgente);
                                let emailAgente = new EnvioEmail();
                                emailAgente.destinatario = agente.email;
                                emailAgente.asunto = asunto;
                                emailAgente.cuerpo = cuerpo;
                                emailAgente.fecha = new Date();
                                emailAgente.enviado = 0;
                                // Adjuntar PDFs
                                emailAgente.adjuntos = adjuntos;
                                envioEmailService.crear(emailAgente);
                            }
                        });
                    });
                }
            });
    }

    public static enviarEmailsEditarPolizaMetodoPago(formularioSolicitud: FormularioSolicitud, dniCliente: Archivo | undefined,
        dniClienteReverso: Archivo | undefined, tipoSolicitud: string, poliza: Poliza, emailTemplateService: EmailTemplateApiService,
        envioEmailService: EnvioEmailApiService, pdfService: PdfApiService, fechaEfecto?: string) {

        const cliente = poliza.cliente;
        const agente = poliza.colectivo?.agente ? poliza.colectivo.agente : poliza.tipoPoliza?.agente;

        pdfService.generarPdfSolicitud(formularioSolicitud)
            .then((pdfSolicitud: Archivo) => {
                if (cliente && agente) {
                    // Generar PDF de coberturas
                    Utilidades.generarPdfColectivoCobertura(poliza.cliente, poliza, pdfService, new DatePipe('en-US')).then((pdfCoberturas: Archivo) => {
                        const variablesCliente = Utilidades.getVariablesEmailEditarPoliza(tipoSolicitud, poliza, fechaEfecto);
                        const variablesAgente = Utilidades.getVariablesEmailEditarPoliza(tipoSolicitud, poliza, fechaEfecto);
                        const adjuntos: Archivo[] = [pdfCoberturas, pdfSolicitud];
                        if (dniCliente) {
                            adjuntos.push(dniCliente);
                        }
                        if (dniClienteReverso) {
                            adjuntos.push(dniClienteReverso);
                        }

                        // Enviar email al cliente
                        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ACCION_CLIENTE).then((template: EmailTemplate) => {
                            if (template) {
                                const asunto = Utilidades.rellenarPlantilla(template.asunto, variablesCliente);
                                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variablesCliente);
                                let emailCliente = new EnvioEmail();
                                emailCliente.destinatario = cliente.email;
                                emailCliente.asunto = asunto;
                                emailCliente.cuerpo = cuerpo;
                                emailCliente.fecha = new Date();
                                emailCliente.enviado = 0;
                                // Adjuntar PDFs
                                emailCliente.adjuntos = adjuntos;
                                envioEmailService.crear(emailCliente);
                            }
                        });

                        // Enviar email al agente
                        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ACCION_AGENTE).then((template: EmailTemplate) => {
                            if (template) {
                                const asunto = Utilidades.rellenarPlantilla(template.asunto, variablesAgente);
                                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variablesAgente);
                                let emailAgente = new EnvioEmail();
                                emailAgente.destinatario = agente.email;
                                emailAgente.asunto = asunto;
                                emailAgente.cuerpo = cuerpo;
                                emailAgente.fecha = new Date();
                                emailAgente.enviado = 0;
                                // Adjuntar PDFs
                                emailAgente.adjuntos = adjuntos;
                                envioEmailService.crear(emailAgente);
                            }
                        });
                    });
                }
            });
    }

    public static enviarEmailsEditarPoliza(tipoSolicitud: string, poliza: Poliza, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, pdfService: PdfApiService, fechaEfecto?: string) {
        const cliente = poliza.cliente;
        const agente = poliza.colectivo?.agente ? poliza.colectivo.agente : poliza.tipoPoliza?.agente;

        if (cliente && agente) {
            // Generar PDF de coberturas
            Utilidades.generarPdfColectivoCobertura(poliza.cliente, poliza, pdfService, new DatePipe('en-US')).then((pdfCoberturas: Archivo) => {
                const variablesCliente = Utilidades.getVariablesEmailEditarPoliza(tipoSolicitud, poliza, fechaEfecto); // Pasar fechaEfecto opcionalmente
                const variablesAgente = Utilidades.getVariablesEmailEditarPoliza(tipoSolicitud, poliza, fechaEfecto); // Pasar fechaEfecto opcionalmente

                // Enviar email al cliente
                emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ACCION_CLIENTE).then((template: EmailTemplate) => {
                    if (template) {
                        const asunto = Utilidades.rellenarPlantilla(template.asunto, variablesCliente);
                        const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variablesCliente);
                        let emailCliente = new EnvioEmail();
                        emailCliente.destinatario = cliente.email;
                        emailCliente.asunto = asunto;
                        emailCliente.cuerpo = cuerpo;
                        emailCliente.fecha = new Date();
                        emailCliente.enviado = 0;
                        // Adjuntar PDFs
                        emailCliente.adjuntos = [pdfCoberturas];
                        envioEmailService.crear(emailCliente);
                    }
                });

                // Enviar email al agente
                emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ACCION_AGENTE).then((template: EmailTemplate) => {
                    if (template) {
                        const asunto = Utilidades.rellenarPlantilla(template.asunto, variablesAgente);
                        const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variablesAgente);
                        let emailAgente = new EnvioEmail();
                        emailAgente.destinatario = agente.email;
                        emailAgente.asunto = asunto;
                        emailAgente.cuerpo = cuerpo;
                        emailAgente.fecha = new Date();
                        emailAgente.enviado = 0;
                        // Adjuntar PDFs
                        emailAgente.adjuntos = [pdfCoberturas];
                        envioEmailService.crear(emailAgente);
                    }
                });
            });
        }
    }


    public static enviarEmailsEditarPolizaCambiarBeneficiarios(formularioSolicitud: FormularioSolicitudCambiarBeneficiarios, dniCliente: Archivo | undefined,
        dniClienteReverso: Archivo | undefined, tipoSolicitud: string, poliza: Poliza, emailTemplateService: EmailTemplateApiService,
        envioEmailService: EnvioEmailApiService, pdfService: PdfApiService) {

        const cliente = poliza.cliente;
        const agente = poliza.colectivo?.agente ? poliza.colectivo.agente : poliza.tipoPoliza?.agente;

        pdfService.generarPdfSolicitudCambiarBeneficiarios(formularioSolicitud)
            .then((pdfSolicitud: Archivo) => {

                if (cliente && agente) {
                    // Generar PDF de coberturas
                    Utilidades.generarPdfColectivoCobertura(poliza.cliente, poliza, pdfService, new DatePipe('en-US')).then((pdfCoberturas: Archivo) => {
                        const variablesCliente = Utilidades.getVariablesEmailEditarPoliza(tipoSolicitud, poliza);
                        const variablesAgente = Utilidades.getVariablesEmailEditarPoliza(tipoSolicitud, poliza);
                        const adjuntos: Archivo[] = [pdfCoberturas, pdfSolicitud];
                        if (dniCliente) {
                            adjuntos.push(dniCliente);
                        }
                        if (dniClienteReverso) {
                            adjuntos.push(dniClienteReverso);
                        }

                        // Enviar email al cliente
                        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ACCION_CLIENTE).then((template: EmailTemplate) => {
                            if (template) {
                                const asunto = Utilidades.rellenarPlantilla(template.asunto, variablesCliente);
                                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variablesCliente);
                                let emailCliente = new EnvioEmail();
                                emailCliente.destinatario = cliente.email;
                                emailCliente.asunto = asunto;
                                emailCliente.cuerpo = cuerpo;
                                emailCliente.fecha = new Date();
                                emailCliente.enviado = 0;
                                //Cambiar pdf que se adjunta
                                emailCliente.adjuntos = adjuntos;
                                envioEmailService.crear(emailCliente);
                            }
                        });

                        // Enviar email al agente
                        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ACCION_AGENTE).then((template: EmailTemplate) => {
                            if (template) {
                                const asunto = Utilidades.rellenarPlantilla(template.asunto, variablesAgente);
                                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variablesAgente);
                                let emailAgente = new EnvioEmail();
                                emailAgente.destinatario = agente.email;
                                emailAgente.asunto = asunto;
                                emailAgente.cuerpo = cuerpo;
                                emailAgente.fecha = new Date();
                                emailAgente.enviado = 0;
                                //Cambiar pdf que se adjunta
                                emailAgente.adjuntos = adjuntos;
                                envioEmailService.crear(emailAgente);
                            }
                        });
                    });
                }
            });
    }

    public static enviarEmailsEditarPolizaReducirCapital(formularioSolicitud: FormularioSolicitudReducirCapital, dniCliente: Archivo | undefined,
        dniClienteReverso: Archivo | undefined, tipoSolicitud: string, poliza: Poliza, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, pdfService: PdfApiService) {
        const cliente = poliza.cliente;
        const agente = poliza.colectivo?.agente ? poliza.colectivo.agente : poliza.tipoPoliza?.agente;

        pdfService.generarPdfSolicitudReducirCapital(formularioSolicitud)
            .then((pdfSolicitud: Archivo) => {

                if (cliente && agente) {
                    // Generar PDF de coberturas
                    Utilidades.generarPdfColectivoCobertura(poliza.cliente, poliza, pdfService, new DatePipe('en-US')).then((pdfCoberturas: Archivo) => {
                        const variablesCliente = Utilidades.getVariablesEmailEditarPoliza(tipoSolicitud, poliza);
                        const variablesAgente = Utilidades.getVariablesEmailEditarPoliza(tipoSolicitud, poliza);
                        const adjuntos: Archivo[] = [pdfCoberturas, pdfSolicitud];
                        if (dniCliente) {
                            adjuntos.push(dniCliente);
                        }
                        if (dniClienteReverso) {
                            adjuntos.push(dniClienteReverso);
                        }

                        // Enviar email al cliente
                        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ACCION_CLIENTE).then((template: EmailTemplate) => {
                            if (template) {
                                const asunto = Utilidades.rellenarPlantilla(template.asunto, variablesCliente);
                                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variablesCliente);
                                let emailCliente = new EnvioEmail();
                                emailCliente.destinatario = cliente.email;
                                emailCliente.asunto = asunto;
                                emailCliente.cuerpo = cuerpo;
                                emailCliente.fecha = new Date();
                                emailCliente.enviado = 0;
                                //Cambiar pdf que se adjunta
                                emailCliente.adjuntos = adjuntos;
                                envioEmailService.crear(emailCliente);
                            }
                        });

                        // Enviar email al agente
                        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ACCION_AGENTE).then((template: EmailTemplate) => {
                            if (template) {
                                const asunto = Utilidades.rellenarPlantilla(template.asunto, variablesAgente);
                                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variablesAgente);
                                let emailAgente = new EnvioEmail();
                                emailAgente.destinatario = agente.email;
                                emailAgente.asunto = asunto;
                                emailAgente.cuerpo = cuerpo;
                                emailAgente.fecha = new Date();
                                emailAgente.enviado = 0;
                                //Cambiar pdf que se adjunta
                                emailAgente.adjuntos = adjuntos;
                                envioEmailService.crear(emailAgente);
                            }
                        });
                    });
                }
            });
    }


    // Genera los pdfs completo y anonimo
    public static generarPdfCompania(poliza: Poliza, polizaApiService: PolizaApiService, pdfService: PdfApiService, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService) {
        pdfService
            .generarPdfColectivoCompanniaCompleto(poliza.id!)
            .then((pdfCompanniaCompleto: Archivo) => {
                pdfService
                    .generarPdfColectivoCompanniaAnonimo(poliza.id!)
                    .then((pdfCompanniaAnonimo: Archivo) => {
                        poliza.archivoAstra = pdfCompanniaCompleto;
                        poliza.archivoAstraAnonimo = pdfCompanniaAnonimo;
                        polizaApiService.actualizar(poliza).then(() => {
                            Utilidades.enviarMailCompannia(poliza, pdfCompanniaCompleto, pdfCompanniaAnonimo, pipeEuroSinDecimales, emailTemplateService, envioEmailService);
                        });
                    });
            });
    }

    public static generarPdfCompaniaIndividual(poliza: Poliza, polizaApiService: PolizaApiService, pdfService: PdfApiService, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService) {
        pdfService.rellenarAkibuPdf(poliza.id!)
            .then((pdfRellenableAkibu: Archivo) => {
                return pdfService.rellenarAkibuPdfSinNumeroPoliza(poliza.id!)
                    .then((pdfRellenableAkibuSinNumeroPoliza: Archivo) => {
                        return pdfService.rellenarPdfSolicitud(poliza.id!)
                            .then((pdfRellenableSolicitud: Archivo) => {
                                poliza.archivoPoliza = pdfRellenableAkibu;
                                poliza.archivoPolizaSimplificado = pdfRellenableAkibuSinNumeroPoliza;
                                poliza.archivoSolicitud = pdfRellenableSolicitud;
                                polizaApiService.actualizar(poliza).then(() => {
                                    Utilidades.enviarMailCompanniaIndividual(poliza, pdfRellenableSolicitud, pdfRellenableAkibu, pdfRellenableAkibuSinNumeroPoliza, pipeEuroSinDecimales, emailTemplateService, envioEmailService);
                                });
                            });
                    });
            });
    }

    // Genera el PDF rellenable de akibu para enviar a Logalty
    public static generarPdfFirmaLogalty(poliza: Poliza, pdfService: PdfApiService) {
        return new Promise<Archivo>((resolve) => {
            pdfService.rellenarAkibuPdf(poliza.id!)
                .then((pdfRellenableAkibu: Archivo) => {
                    resolve(pdfRellenableAkibu);
                });
        });
    }


    // Genera el pdf de coberturas de colectivo y envia los emails al cliente y los beneficiarios correspondientes
    public static generarPdfCoberturasEnviarEmail(poliza: Poliza, pdfService: PdfApiService, datePipe: DatePipe, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales) {
        Utilidades.generarPdfColectivoCobertura(poliza.cliente, poliza, pdfService, datePipe).then((pdf) => {
            if (pdf) {
                Utilidades.enviarMailClientePoliza(pdf, poliza, emailTemplateService, envioEmailService, pipeEuroSinDecimales);
                if (poliza.autorizacionEnvioEmail && poliza.beneficiarioList.length > 0) {
                    setTimeout(() => {
                        Utilidades.enviarMailBeneficiarios(poliza, emailTemplateService, envioEmailService, Utilidades.getVariablesEmail(pdf, poliza, pipeEuroSinDecimales));
                    }, 1000);
                }
            }
        });
    }

    // Genera el pdf de coberturas de individual y envia los emails al cliente y los beneficiarios correspondientes
    public static generarPdfCoberturasEnviarEmailIndividual(poliza: Poliza, pdfService: PdfApiService, datePipe: DatePipe, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales) {
        Utilidades.generarPdfIndividualCobertura(poliza.cliente, poliza, pdfService, datePipe)
            .then((pdfCobertura: Archivo) => {
                if (pdfCobertura) {
                    pdfService.rellenarAkibuPdf(poliza.id!)
                        .then((pdfRellenableAkibu: Archivo) => {
                            Utilidades.enviarMailClientePolizaIndividual(pdfRellenableAkibu, poliza, emailTemplateService, envioEmailService, pipeEuroSinDecimales);
                            if (poliza.autorizacionEnvioEmail && poliza.beneficiarioList.length > 0) {
                                Utilidades.enviarMailBeneficiariosIndividual(poliza, emailTemplateService, envioEmailService,
                                    Utilidades.getVariablesEmailIndividual(pdfCobertura, poliza, pipeEuroSinDecimales),
                                );
                            }
                        });
                }
            });
    }

    // Genera el pdf de coberturas de individual, recupera LogaltyFirmado y envia los emails al cliente, beneficiarios y agente correspondiente con los PDFs correspondientes
    public static generarPdfsPolizaEnviarEmailsIndividualLogalty(poliza: Poliza, polizaApiService: PolizaApiService, pdfService: PdfApiService, logaltyService: LogaltyApiService, datePipe: DatePipe, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, pipeEuroSinDecimales: PipeCurrencyEuroSinDecimales) {
        Utilidades.generarPdfIndividualCobertura(poliza.cliente, poliza, pdfService, datePipe)
            .then((pdfCobertura: Archivo) => {
                if (pdfCobertura) {
                    logaltyService.recuperarPdfFirmadoLogalty(poliza.id!)
                        .then((pdfRellenableAkibu: Archivo) => {
                            return pdfService.rellenarAkibuPdfSinNumeroPoliza(poliza.id!)
                                .then((pdfRellenableAkibuSinNumeroPoliza: Archivo) => {
                                    return pdfService.rellenarPdfSolicitud(poliza.id!)
                                        .then((pdfRellenableSolicitud: Archivo) => {
                                            poliza.archivoPoliza = pdfRellenableAkibu;
                                            poliza.archivoPolizaSimplificado = pdfRellenableAkibuSinNumeroPoliza;
                                            poliza.archivoSolicitud = pdfRellenableSolicitud;
                                            polizaApiService.actualizar(poliza).then(() => {
                                                Utilidades.enviarMailCompanniaIndividual(poliza, pdfRellenableSolicitud, pdfRellenableAkibu, pdfRellenableAkibuSinNumeroPoliza, pipeEuroSinDecimales, emailTemplateService, envioEmailService);
                                                setTimeout(() => {
                                                    Utilidades.enviarMailClientePolizaIndividual(pdfRellenableAkibu, poliza, emailTemplateService, envioEmailService, pipeEuroSinDecimales);
                                                }, 5000);
                                                if (poliza.autorizacionEnvioEmail && poliza.beneficiarioList.length > 0) {
                                                    setTimeout(() => {
                                                        Utilidades.enviarMailBeneficiariosIndividual(poliza, emailTemplateService, envioEmailService,
                                                            Utilidades.getVariablesEmailIndividual(pdfCobertura, poliza, pipeEuroSinDecimales),
                                                        );
                                                    }, 5000);
                                                }
                                            });
                                        });

                                });
                        });
                }
            });
    }


    public static solicitarFirmaCliente(emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, poliza: Poliza, datosOperacion: any, operacionTituloEmail: string) {
        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_SOLICITUD_FIRMA_ID).then((template: EmailTemplate) => {
            if (template) {
                const enlaceFirma = `${environment.staticUrlHost}/user/firma?token=${datosOperacion}`;

                // preparamos las variables
                let variables = { staticContentPath: environment.staticContentPath, operacionTituloEmail: operacionTituloEmail, enlaceFirma: enlaceFirma };
                const asunto = Utilidades.rellenarPlantilla(template.asunto, variables);
                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variables);

                const envioEmail = new EnvioEmail();
                envioEmail.destinatario = poliza.cliente.email;
                envioEmail.asunto = asunto;
                envioEmail.cuerpo = cuerpo;
                envioEmail.fecha = new Date();
                envioEmail.enviado = 0;

                envioEmail.adjuntos = [];

                envioEmailService.crear(envioEmail);
            }
        });
    }

    public static enviarMailSetNewPassword(email, userService: UserService, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, poliza?: Poliza) {
        userService.getUserToken(email).subscribe({
            next: (response: any) => {
                let tokenChangePass = response.token;
                // recuperamos la plantilla
                emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_RESETPASSWORD_ID).then((template: EmailTemplate) => {
                    if (template) {

                        // preparamos las variables
                        let urlActual = new URL(window.location.href).origin;
                        let pathSetPassword = `${urlActual}${ConstantesApp.ROUTING_USER_NUEVO_PASSWORD}?token=${tokenChangePass}`;
                        let variables = {
                            staticContentPath: environment.staticContentPath,
                            emailCliente: email,
                            enlaceEstablecerPassword: pathSetPassword,
                            urlLogo: poliza?.colectivo?.archivoLogo.url ? poliza?.colectivo?.archivoLogo.url : ConstantesApp.LOGO_ASTRA
                        };
                        const asuntoEmailNewPass = Utilidades.rellenarPlantilla(template.asunto, variables);
                        const cuerpoEmailNewPass = Utilidades.rellenarPlantilla(template.cuerpo, variables);

                        const envioEmailNewPass = new EnvioEmail();
                        envioEmailNewPass.destinatario = email;
                        envioEmailNewPass.asunto = asuntoEmailNewPass;
                        envioEmailNewPass.cuerpo = cuerpoEmailNewPass;
                        envioEmailNewPass.fecha = new Date();
                        envioEmailNewPass.enviado = 0;

                        envioEmailNewPass.adjuntos = [];

                        envioEmailService.crear(envioEmailNewPass);
                    }
                });
            },
            error: (error: any) => {
            }
        });
    }

    public static enviarMailSetNewPasswordIndividual(email, userService: UserService, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, poliza?: Poliza) {
        userService.getUserToken(email).subscribe({
            next: (response: any) => {
                let tokenChangePass = response.token;
                // recuperamos la plantilla
                emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_INDIVIDUAL_RESETPASSWORD_ID).then((template: EmailTemplate) => {
                    if (template) {

                        // preparamos las variables
                        let urlActual = new URL(window.location.href).origin;
                        let pathSetPassword = `${urlActual}${ConstantesApp.ROUTING_USER_NUEVO_PASSWORD}?token=${tokenChangePass}`;
                        let variables = {
                            staticContentPath: environment.staticContentPath,
                            emailCliente: email,
                            enlaceEstablecerPassword: pathSetPassword,
                            urlLogo: ConstantesApp.LOGO_AXA,
                        };
                        const asuntoEmailNewPass = Utilidades.rellenarPlantilla(template.asunto, variables);
                        const cuerpoEmailNewPass = Utilidades.rellenarPlantilla(template.cuerpo, variables);

                        const envioEmailNewPass = new EnvioEmail();
                        envioEmailNewPass.destinatario = email;
                        envioEmailNewPass.asunto = asuntoEmailNewPass;
                        envioEmailNewPass.cuerpo = cuerpoEmailNewPass;
                        envioEmailNewPass.fecha = new Date();
                        envioEmailNewPass.enviado = 0;

                        envioEmailNewPass.adjuntos = [];

                        envioEmailService.crear(envioEmailNewPass);
                    }
                });
            },
            error: (error: any) => {
                if (error.status === 403) {
                    console.error('Otro error:', error);
                }
            }
        });
    }

    public static generarPdfIndividualCobertura(cliente: Cliente, poliza: Poliza, pdfService: PdfApiService, datePipe: DatePipe) {
        return new Promise<Archivo>((resolve, reject) => {
            const formularioPresupuesto = new FormularioPresupuesto();
            formularioPresupuesto.clienteId = cliente.id;
            formularioPresupuesto.titular = Utilidades.getNombreCompletoCliente(cliente);
            formularioPresupuesto.nacimiento = datePipe.transform(cliente.fechaNacimiento, 'yyyy-MM-dd')!.toString();
            formularioPresupuesto.email = cliente.email;
            formularioPresupuesto.telefono = cliente.telefono;
            formularioPresupuesto.formaPago = poliza.tipoPeriodicidad?.descripcion!;
            formularioPresupuesto.fechaInicioCobertura = '';
            formularioPresupuesto.profesion = cliente.profesion;
            formularioPresupuesto.tipoPoliza = poliza.tipoPoliza.nombre;
            formularioPresupuesto.tipoPolizaDescripcion = poliza.tipoPoliza.descripcion;
            formularioPresupuesto.fallecimientoCausa = poliza.capitalCobertura;
            formularioPresupuesto.fallecimientoAccidente = poliza.capitalAccidenteFallecimiento;
            formularioPresupuesto.invalidezAccidente = poliza.capitalAccidenteInvalidez;

            if (poliza.incluidoFallecimientoAccidente == true) {
                formularioPresupuesto.incluidoFallecimientoAccidente = poliza.incluidoFallecimientoAccidente;
            }
            if (poliza.incluidoInvalidezAccidente == true) {
                formularioPresupuesto.incluidoInvalidezAccidente = poliza.incluidoInvalidezAccidente;
            }

            formularioPresupuesto.precioMensual = poliza.precioMensual;

            const agente = poliza.tipoPoliza!.agente
            formularioPresupuesto.nombreAgente = agente!.nombreApellidos;
            formularioPresupuesto.emailAgente = agente!.email;
            formularioPresupuesto.telefonoAgente = agente!.telefono;

            pdfService
                .generarPdfIndividualCobertura(formularioPresupuesto)
                .then((pdf: Archivo) => {
                    resolve(pdf);
                });
        });

    }

    public static enviarEmailErrorPago(email: string, numeroPoliza: string, nombreCliente: string, importe: string, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService, pipeEuro: PipeCurrencyEuro) {
        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ERROR_PAGO_ID).then((template: EmailTemplate) => {
            if (template) {

                // preparamos las variables
                let variables = {
                    staticContentPath: environment.staticContentPath,
                    numeroPoliza: numeroPoliza,
                    nombreCliente: nombreCliente,
                    importe: pipeEuro.transform(Number(importe) / 100)
                };
                const asuntoEmailErrorPago = Utilidades.rellenarPlantilla(template.asunto, variables);
                const cuerpoEmailErrorPago = Utilidades.rellenarPlantilla(template.cuerpo, variables);

                const envioEmailErrorPago = new EnvioEmail();
                envioEmailErrorPago.destinatario = email;
                envioEmailErrorPago.asunto = asuntoEmailErrorPago;
                envioEmailErrorPago.cuerpo = cuerpoEmailErrorPago;
                envioEmailErrorPago.fecha = new Date();
                envioEmailErrorPago.enviado = 0;

                envioEmailErrorPago.adjuntos = [];

                envioEmailService.crear(envioEmailErrorPago);
            }
        });
    }

    public static enviarEmailErrorFirmaLogalty(email: string, numeroPoliza: string, nombreCliente: string, nombreAgente: string, emailTemplateService: EmailTemplateApiService, envioEmailService: EnvioEmailApiService) {
        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ERROR_FIRMA_LOGALTY_ID).then((template: EmailTemplate) => {
            if (template) {
                // preparamos las variables
                let variables = {
                    staticContentPath: environment.staticContentPath,
                    numeroPoliza: numeroPoliza,
                    nombreCliente: nombreCliente,
                    nombreAgente: nombreAgente,
                };
                const asuntoEmailErrorFirmaLogalty = Utilidades.rellenarPlantilla(template.asunto, variables);
                const cuerpoEmailErrorFirmaLogalty = Utilidades.rellenarPlantilla(template.cuerpo, variables);

                const envioEmailErrorFirmaLogalty = new EnvioEmail();
                envioEmailErrorFirmaLogalty.destinatario = email;
                envioEmailErrorFirmaLogalty.asunto = asuntoEmailErrorFirmaLogalty;
                envioEmailErrorFirmaLogalty.cuerpo = cuerpoEmailErrorFirmaLogalty;
                envioEmailErrorFirmaLogalty.fecha = new Date();
                envioEmailErrorFirmaLogalty.enviado = 0;

                envioEmailErrorFirmaLogalty.adjuntos = [];

                envioEmailService.crear(envioEmailErrorFirmaLogalty);
            }
        });
    }

    public static getRecibos(tipoPeriodicidad: number | undefined): number {
        let recibos = 1;

        if (!tipoPeriodicidad) {
            return recibos;
        }


        switch (tipoPeriodicidad) {
            case 4:
                recibos = 12;
                break;
            case 1:
                recibos = 4;
                break;
            case 2:
                recibos = 2;
                break;
            case 3:
                recibos = 1;
                break;
            default:
                recibos = 1;
                break;
        }

        return recibos;
    }

    public static calcularCapitalMaxGarantizadoFallAccidente(capitalCobertura: number, capitalAccidenteFallecimiento: number, edadActuarial: number): number {
        if ((capitalCobertura === 0 || capitalAccidenteFallecimiento === 0)
            || (edadActuarial < 18 || edadActuarial > 64)) {
            return 0;
        }
        const maxCapital = capitalAccidenteFallecimiento * 5;
        return capitalAccidenteFallecimiento > maxCapital ? maxCapital : capitalAccidenteFallecimiento;
    }

    public static calcularCapitalMaxGarantizadoIpa(capitalCobertura: number, capitalAccidenteInvalidez: number, edadActuarial: number): number {
        if ((capitalCobertura === 0 || capitalAccidenteInvalidez === 0)
            || (edadActuarial < 18 || edadActuarial > 64)) {
            return 0;
        }

        const maxCapital = capitalCobertura * 5;
        return Math.min(500000, Math.min(capitalAccidenteInvalidez, maxCapital));
    }

    public static calcularCapitalAseguradoFallAccidente(capitalCobertura: number, capitalAccidenteFallecimiento: number): number {
        const suma = capitalCobertura + capitalAccidenteFallecimiento;

        if (suma > 500000) {
            return 500000 - capitalCobertura;
        } else {
            return capitalAccidenteFallecimiento;
        }
    }

    public static calcularCapitalFallecimientoAccidente(capitalCobertura: number, capitalAccidenteFallecimiento: number, edadActuarial: number): number {
        if (capitalCobertura === 0 || capitalAccidenteFallecimiento === 0 ||
            edadActuarial < 18 || edadActuarial > 64) {
            return Utilidades.calcularCapitalMaxGarantizadoFallAccidente(capitalCobertura, capitalAccidenteFallecimiento, edadActuarial);
        }

        return Utilidades.calcularCapitalAseguradoFallAccidente(capitalCobertura, capitalAccidenteFallecimiento);
    }

    public static calcularSobreprima(poliza: Poliza, hipertension: boolean, insulinaDependiente: boolean, noInsulinaDependiente: boolean): Poliza {

        if (hipertension) {
            if (poliza.capitalCobertura > 300000) {
                poliza.calculosPoliza!.sobreprimaFallecimiento = 0.5;
                poliza.calculosPoliza!.sobreprimaIpa = 0.5;
            }
        }

        if (insulinaDependiente || noInsulinaDependiente) {


            if (insulinaDependiente) {
                if (poliza.capitalCobertura > 300000) {
                    poliza.calculosPoliza!.sobreprimaFallecimiento += 1.5;
                    poliza.rechazoIpa = true;


                } else if (poliza.capitalCobertura <= 300000) {
                    poliza.calculosPoliza!.sobreprimaFallecimiento += 1.25;
                    poliza.calculosPoliza!.sobreprimaIpa += 1.75
                    poliza.rechazoIpa = false;
                }
            }

            if (noInsulinaDependiente) {
                if (poliza.capitalCobertura > 300000) {
                    poliza.calculosPoliza!.sobreprimaFallecimiento += 1.25;
                    poliza.rechazoIpa = true;

                } else if (poliza.capitalCobertura <= 300000) {
                    poliza.calculosPoliza!.sobreprimaFallecimiento += 1;
                    poliza.calculosPoliza!.sobreprimaIpa += 1.5;
                    poliza.rechazoIpa = false;
                }
            }
        } else {
            poliza.rechazoIpa = false;
        }
        return poliza;
    }

    public static enviarMailEnfermedadCliente(
        poliza: Poliza,
        emailTemplateService: EmailTemplateApiService,
        envioEmailService: EnvioEmailApiService
    ) {
        emailTemplateService.obtenerById(ConstantesApp.PLANTILLA_EMAIL_ENFERMEDAD_CLIENTE).then((template: EmailTemplate) => {
            if (template) {
                const agente = poliza.colectivo?.agente || poliza.tipoPoliza?.agente;
                if (!agente?.email) return;

                const variables = {
                    nombreAgente: agente.nombreApellidos,
                    emailCliente: poliza.cliente.email,
                };

                const asunto = Utilidades.rellenarPlantilla(template.asunto, variables);
                const cuerpo = Utilidades.rellenarPlantilla(template.cuerpo, variables);

                const envioEmail = new EnvioEmail();
                envioEmail.destinatario = agente.email;
                envioEmail.asunto = asunto;
                envioEmail.cuerpo = cuerpo;
                envioEmail.fecha = new Date();
                envioEmail.enviado = 0;
                envioEmail.adjuntos = [];

                envioEmailService.crear(envioEmail);
            }
        });
    }

}
